export default "__VITE_ASSET__zDEPhbhL__"